import { render } from "./Circulacao.vue?vue&type=template&id=788aeb64"
import script from "./Circulacao.vue?vue&type=script&lang=js"
export * from "./Circulacao.vue?vue&type=script&lang=js"

import "./Circulacao.vue?vue&type=style&index=0&id=788aeb64&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__